export const translations = {
  sv: {
    // Cart
    "Your Cart": "Din Kundvagn",
    "Your cart is empty": "Din kundvagn är tom",
    "Remove": "Ta bort",
    "Checkout": "Till kassan",
    "items": "st",
    "item": "st",
    "Estimated Total": "Beräknad summa",
    "Out of stock": "Tillfälligt slut",
    "Remove sold out items": "Ta bort slutsålda varor",
    "Some items in your cart are out of stock. Remove them to continue.": "Vissa varor i kundvagnen är tillfälligt slut. Ta bort dem för att fortsätta.",
    "One or more items are out of stock. Remove them before checkout.": "En eller flera produkter är tillfälligt slut. Ta bort dem innan checkout.",
    "Some items are out of stock. Remove them before placing your order.": "Vissa varor är tillfälligt slut. Ta bort dem innan du lägger beställningen.",

    // Nav
    "Hem": "Hem",
    "Meny": "Meny",
    "Orders": "Beställningar",
    "Om oss": "Om oss",
    "Profil": "Profil",
    "Logga in": "Logga in",
    "Admin": "Admin",
    "Ljust läge": "Ljust läge",
    "Mörkt läge": "Mörkt läge",
    "Call us": "Ring oss",
    "Öppna meny": "Öppna meny",
    "Stäng": "Stäng",
    "Byt": "Byt",
    "Byt restaurang": "Byt restaurang",
    "Restaurang & Catering": "Restaurang & Catering",
    "Navigation": "Navigering",
    "Information": "Information",
    "Integritetspolicy": "Integritetspolicy",
    "Användarvillkor": "Användarvillkor",
    "Noggrant utvalda råvaror, lagade med kärlek och omsorg. Beställ för avhämtning eller leverans.": "Noggrant utvalda råvaror, lagade med kärlek och omsorg. Beställ för avhämtning eller leverans.",
    "Maten du ser fram emot": "Maten du ser fram emot",
    "hela dagen": "hela dagen",
    "Avhämtning": "Avhämtning",
    "Leverans": "Leverans",
    "Catering": "Catering",
    "Färska råvaror": "Färska råvaror",
    "Lagat med kärlek": "Lagat med kärlek",
    "Rulla": "Rulla",
    "Utforska menyn": "Utforska menyn",
    "En upplevelse,": "En upplevelse,",
    "inte bara en måltid": "inte bara en måltid",
    "Signaturrätt med balanserade smaker och premiumråvaror.": "Signaturrätt med balanserade smaker och premiumråvaror.",
    "Bästa Biten": "Bästa Biten",
    "Orderstatus": "Orderstatus",
    "Din beställnings resa": "Din beställnings resa",
    "We're closed right now and not accepting orders.": "Vi har stängt just nu och tar inte emot beställningar.",

    // HomePage
    "Choose your Biten": "Välj din Bästa Biten",
    "Where are you? Choose location to see menu and order.": "Vart befinner du dig? Välj ort för att se lokal meny och göra en beställning.",
    "Luxury Street Dining": "Luxury Street Dining",
    "The food you look forward to all day": "Maten du ser fram emot hela dagen",
    "Order faster, eat better. We combine premium quality with fast delivery.": "Beställ snabbare, ät godare. Vi kombinerar premiumkänsla med snabb leverans och en meny som gör det enkelt att välja rätt favorit direkt.",
    "Menu": "Meny",
    "Why choose us": "Varför välja oss",
    "Customer rating": "Kundbetyg",
    "Dishes": "Rätter",
    "Local zone": "Lokal zon",
    "Popular right now": "Populärt just nu",
    "Most popular dishes": "Mest omtyckta rätter",
    "See full menu": "Se hela menyn",
    "Order this in the menu": "Beställ denna i menyn",
    "Menu is being updated. Open menu to see all dishes.": "Menyn uppdateras just nu. Öppna menyn för att se alla tillgängliga rätter.",
    "Customer feedback": "Kundfeedback",
    "What customers say": "Vad kunderna säger",
    "out of 5 average": "/5 genomsnitt",
    "Hungry already?": "Hungrig redan nu?",
    "Open the menu and place your order in under a minute.": "Öppna menyn och lägg din beställning på under en minut.",

    // Highlights
    "Premiumsmaker": "Premiumsmaker",
    "Säsongsanpassade råvaror och signaturrätter som känns restauranglyxiga hemma.": "Säsongsanpassade råvaror och signaturrätter som känns restauranglyxiga hemma.",
    "Snabbt och smidigt": "Snabbt och smidigt",
    "Från meny till beställning på minuter, med tydlig orderstatus hela vägen.": "Från meny till beställning på minuter, med tydlig orderstatus hela vägen.",
    "Lokalt levererat": "Lokalt levererat",
    "Leverans inom vårt lokala område med fokus på temperatur, timing och kvalitet.": "Leverans inom vårt lokala område med fokus på temperatur, timing och kvalitet.",
    "Pålitlig service": "Pålitlig service",
    "Hundratals nöjda kunder och en upplevelse som är byggd för återbeställning.": "Hundratals nöjda kunder och en upplevelse som är byggd för återbeställning.",

    // HomePage English equivalents for highlights
    "Premiumsmaker_en": "Premium Flavors",
    "Säsongsanpassade råvaror och signaturrätter som känns restauranglyxiga hemma._en": "Seasonal ingredients and signature dishes that feel restaurant-luxury at home.",
    "Snabbt och smidigt_en": "Fast & Smooth",
    "Från meny till beställning på minuter, med tydlig orderstatus hela vägen._en": "From menu to order in minutes, with clear order status all the way.",
    "Lokalt levererat_en": "Locally Delivered",
    "Leverans inom vårt lokala område med fokus på temperatur, timing och kvalitet._en": "Delivery within our local area with focus on temperature, timing and quality.",
    "Pålitlig service_en": "Reliable Service",
    "Hundratals nöjda kunder och en upplevelse som är byggd för återbeställning._en": "Hundreds of satisfied customers and an experience built for repeat orders.",

    // MenuPage
    "Chef's Pick": "Kockens Val",
    "TOP PICK": "MEST SÅLDA",
    "Order now": "Beställ nu",
    "No items in this category": "Inga rätter i denna kategori",
    "Menu heading": "Meny",

    // ProductDetail
    "Ingredients": "Ingredienser",
    "Tap to remove what you don't want": "Tryck för att ta bort det du inte vill ha",
    "Extras & Add-ons": "Extra & Tillbehör",
    "Customize your order": "Anpassa din beställning",
    "Choose one": "Välj ett alternativ",
    "Add": "Lägg till",
    "Product not found": "Produkten hittades inte",
    "This product cannot be ordered right now.": "denna produkt går inte att beställa just nu.",
    "added to cart": "tillagd i varukorgen",
    "Allergens": "Allergener",
    "Contains the following allergens": "Innehåller följande allergener",
    "No allergens listed. Ask our staff about allergens before ordering.": "Inga allergener angivna. Fråga personalen om allergener innan du beställer.",
    "Verifiera ditt telefonnummer": "Verifiera ditt telefonnummer",
    "För leverans behöver vi kunna nå dig på": "För leverans behöver vi kunna nå dig på",
    "Skicka kod via SMS": "Skicka kod via SMS",
    "Vi har skickat en kod via SMS": "Vi har skickat en kod via SMS",
    "Kunde inte skicka kod": "Kunde inte skicka kod",
    "Telefonnummer verifierat!": "Telefonnummer verifierat!",
    "Fel kod": "Fel kod",
    "Verifiera": "Verifiera",
    "Skicka igen om": "Skicka igen om",
    "Skicka ny kod": "Skicka ny kod",
    "Verify your phone number to order delivery.": "Verifiera ditt telefonnummer för att beställa leverans.",
    "Verifierar din e-post...": "Verifierar din e-post...",
    "E-post bekräftad!": "E-post bekräftad!",
    "Tack! Din e-postadress är nu verifierad.": "Tack! Din e-postadress är nu verifierad.",
    "Länken är ogiltig": "Länken är ogiltig",
    "Länken kan ha gått ut eller redan använts. Begär en ny från din profil.": "Länken kan ha gått ut eller redan använts. Begär en ny från din profil.",
    "Till profilen": "Till profilen",
    "Verify email": "Verifiera e-post",
    "Resend verification email": "Skicka verifieringsmail igen",
    "Verification email sent": "Verifieringsmail skickat",
    "Verify now": "Verifiera nu",
    "Your email is not verified yet.": "Din e-post är inte verifierad än.",

    // Checkout
    "Checkout Title": "Kassan",
    "How would you like your order?": "Hur vill du ha din beställning?",
    "Pickup": "Avhämtning",
    "Delivery": "Leverans",
    "Delivery Address": "Leveransadress",
    "Street address": "Gatuadress",
    "City": "Postort",
    "Home": "Hem",
    "Work": "Jobb",
    "Other": "Annan",
    "Order Summary": "Beställningsöversikt",
    "Subtotal": "Delsumma",
    "Delivery fee": "Leveransavgift",
    "Discount": "Rabatt",
    "Total": "Totalt",
    "Special Instructions": "Särskilda önskemål",
    "Any allergies, preferences, or messages for the kitchen?": "Allergier, preferenser eller annat köket bör veta?",
    "Place Order": "Slutför beställning",
    "Placing Order...": "Skickar...",
    "Promo code": "Rabattkod",
    "Enter promo code": "Skriv rabattkod",
    "Apply": "Använd",
    "Remove promo": "Ta bort",
    "Promo code active": "Rabattkod aktiv",
    "Payment on delivery": "Betalning vid leverans",
    "Payment on pickup": "Betalning vid avhämtning",
    "You pay when you receive your delivery": "Du betalar när du tar emot din leverans",
    "You pay when you pick up your order": "Du betalar när du hämtar din beställning",
    "No card payment needed now.": "– ingen kortbetalning krävs nu.",
    "Save address to profile?": "Spara adress i profil?",
    "This address is not saved in your profile. Save it now?": "Den här adressen är inte sparad i din profil. Vill du spara den nu?",
    "Address type": "Adress-typ",
    "No, continue": "Nej, fortsätt",
    "Yes, save": "Ja, spara",
    "We're closed and not accepting orders.": "Vi har stängt just nu och tar inte emot beställningar.",
    "Pickup temporarily unavailable.": "Avhämtning är tillfälligt avstängd.",
    "Delivery temporarily unavailable.": "Leverans är tillfälligt avstängd.",
    "One or more products are out of stock. Remove them to order.": "En eller flera produkter är tillfälligt slut. Ta bort dem för att beställa.",
    "Minimum order amount is": "Minsta orderbelopp är",
    "Please enter your delivery address": "Ange din leveransadress",
    "Failed to place order": "Det gick inte att lägga beställningen",
    "Address saved to profile": "Adressen sparades i din profil",
    "Order placed, but address could not be saved": "Ordern lades, men adressen kunde inte sparas",
    "Orders temporarily suspended": "Beställning tillfälligt avstängd",
    "Min": "Minst",
    "required": "krävs",
    "Restaurant is temporarily not accepting orders.": "Restaurangen tar tillfälligt inte emot nya beställningar.",
    "Temporarily unavailable": "Tillfälligt avstängt",

    // Auth
    "Welcome": "Välkommen",
    "Welcome back": "Välkommen tillbaka",
    "Sign in to your account": "Logga in på ditt konto",
    "Sign in to continue": "Logga in för att fortsätta",
    "Create Account": "Skapa Konto",
    "Create account": "Skapa konto",
    "Join biten for the best dining experience": "Gå med i biten för den bästa matupplevelsen",
    "Full Name": "För- och efternamn",
    "Phone Number": "Telefonnummer",
    "Email": "E-post",
    "Email or Phone": "E-post eller telefon",
    "Password": "Lösenord",
    "Don't have an account?": "Har du inget konto?",
    "Sign up": "Skapa konto",
    "Already have an account?": "Har du redan ett konto?",
    "Sign in": "Logga in",
    "Sign In": "Logga in",
    "Please wait...": "Var god vänta...",
    "Please fill all fields": "Fyll i alla fält",
    "Something went wrong": "Något gick fel",
    "Welcome back!": "Välkommen tillbaka!",
    "Account created!": "Konto skapat!",
    "Local test mode": "Lokalt testläge",
    "Switch to Admin Dashboard": "Växla till Adminpanelen",

    // Profile
    "My Profile": "Min Profil",
    "Manage your details and addresses": "Hantera dina uppgifter och adresser",
    "Personal Info": "Personuppgifter",
    "Edit": "Redigera",
    "NAME": "NAMN",
    "EMAIL": "E-POST",
    "PHONE": "TELEFON",
    "VERIFIED": "VERIFIERAD",
    "Yes": "Ja",
    "No": "Nej",
    "My Addresses": "Mina Adresser",
    "Add": "Lägg till",
    "Set as default": "Sätt som standard",
    "No address saved": "Ingen adress sparad",
    "Add first address": "Lägg till första adressen",
    "Standard": "Standard",
    "Account Management": "Kontohantering",
    "Report a problem": "Kontakta oss",
    "Tell us if you experience any disruptions or issues with the website.": "Har du frågor, eller upplever du störningar eller problem med hemsidan? Skriv till oss här så återkommer vi.",
    "Describe the problem…": "Skriv ditt meddelande…",
    "Send message": "Skicka meddelande",
    "Please write a message first": "Skriv ett meddelande först",
    "Thanks! Your message has been sent.": "Tack! Ditt meddelande har skickats.",
    "Could not send. Please try again.": "Kunde inte skicka. Försök igen.",
    "Logout": "Logga ut",
    "Delete Account": "Radera konto",
    "Language": "Språk",
    "Switch to English": "Byt till Engelska",
    "Switch to Swedish": "Byt till Svenska",
    "Not logged in": "Inte inloggad",
    "Go Home": "Gå till startsidan",
    "Edit profile": "Redigera profil",
    "Name": "Namn",
    "Phone": "Telefon",
    "Save": "Spara",
    "Cancel": "Avbryt",
    "Delete": "Radera",
    "Confirm": "Bekräfta",
    "Back": "Tillbaka",
    "Add address": "Lägg till adress",
    "You already have this address saved": "Du har redan sparat denna adressen",
    "Street": "Gata",
    "Town": "Stad",
    "Fill all fields": "Fyll i alla fält",
    "Profile updated": "Profil uppdaterad",
    "Failed to load profile": "Kunde inte ladda profil",
    "Failed to update profile": "Kunde inte uppdatera profil",
    "Address added": "Adress tillagd",
    "Address deleted": "Adress raderad",
    "Failed to add address": "Kunde inte lägga till adress",
    "Failed to delete address": "Kunde inte radera adress",
    "Default address updated": "Standardadress uppdaterad",
    "Could not update default address": "Kunde inte uppdatera standardadress",
    "Delete this address?": "Radera denna adress?",
    "Are you sure you want to delete your account? This cannot be undone.": "Är du säker på att du vill radera ditt konto? Denna åtgärd kan inte ångras.",
    "Your account has been deleted": "Ditt konto har raderats",
    "Could not delete account": "Kunde inte radera kontot",
    "Logged out": "Utloggad",
    "Fill all address fields": "Fyll i alla adressfält",

    // OrderTracking
    "My Orders": "Mina beställningar",
    "Order": "Order",
    "Receipt": "Kvitto",
    "Items": "Artiklar",
    "Your note": "Din anteckning",
    "Delivery address": "Leveransadress",
    "Without": "Utan",
    "Cancel order": "Avbryt beställning",
    "Order cancelled": "Order avbruten",
    "Could not cancel": "Kan inte avbryta",
    "Order not found": "Order hittades inte",
    "Rate your order": "Betygsätt din beställning",
    "How was the food? Your rating helps us improve.": "Hur var maten? Ditt omdöme hjälper oss bli bättre.",
    "Leave a comment (optional)...": "Lämna en kommentar (valfritt)...",
    "Submit review": "Skicka recension",
    "Thanks for your review!": "Tack för din recension!",
    "Could not submit review": "Kunde inte skicka recension",
    "Select number of stars": "Välj antal stjärnor",
    "Reorder": "Beställ samma igen",
    "Back to menu": "Tillbaka till menyn",
    "Problem? Call us:": "Problem? Ring oss:",
    "Your review": "Din recension",
    "Order again": "Beställ samma igen",
    "articles added to cart": "artiklar tillagda i varukorgen",
    "article": "artikel",
    "articles": "artiklar",
    "items added to cart": "artiklar tillagda i varukorgen",
    "products no longer available": "produkter finns inte längre",
    "We added the rest to your cart.": "Vi la till resten i varukorgen.",
    "Try instead:": "Prova istället:",
    "These products are no longer on the menu.": "Dessa produkter finns inte längre i menyn.",
    "Could not reorder right now": "Kunde inte lägga till samma produkter just nu",
    "Recommendation": "Passa på att beställa något annat",

    // Status labels
    "waiting_for_confirmation": "Väntar på restaurangen",
    "New": "Ny",
    "Accepted": "Accepterad",
    "Rejected": "Avvisad",
    "Preparing": "Tillagas",
    "Ready": "Redo",
    "Completed": "Klar",
    "Cancelled": "Avbruten",
    "Paid": "Bekräftad",
    "Confirmed — waiting for preparation": "Bekräftad — väntar på tillagning",
    "Your food is being prepared...": "Din mat tillagas nu...",
    "Ready for pickup!": "Redo att hämtas!",
    "Waiting for restaurant...": "Väntar på restaurangen...",
    "No review yet": "Ingen recension ännu",

    // OrderHistory
    "Your orders": "Dina beställningar",
    "Active orders": "Aktiva beställningar",
    "Previous orders": "Tidigare beställningar",
    "No orders yet": "Inga beställningar ännu",
    "See menu": "Se menyn",

    // About
    "About Us": "Om Oss",
    "Get to know the restaurant": "Lär känna restaurangen",
    "Opening Hours": "ÖPPETTIDER",
    "Address label": "ADRESS",
    "Phone label": "TELEFON",
    "Services": "Tjänster",
    "Pickup service": "Hämtning",
    "Pick up your food at the restaurant": "Hämta din mat på restaurangen",
    "Delivery service": "Leverans",
    "We deliver food to your home": "Vi levererar mat till ditt hem",
    "About the restaurant": "Om Restaurangen",
    "Delivery Info": "Leverans",
    "Delivery fee label": "LEVERANSAVGIFT",
    "Delivery area": "LEVERANSOMRÅDE",
    "Up to": "Upp till",
    "min away": "min bort",
    "Announcement": "Meddelande",
    "Gallery": "Galleri",
    "Terms & Privacy": "Villkor & Integritet",
    "Privacy Policy": "Integritetspolicy",
    "Terms of Service": "Allmänna Villkor",
    "Closed": "Stängt",
    "Opening hours not yet set": "Öppettider ej angivna",

    // CookieBanner
    "We use cookies to improve your experience. Some cookies are necessary while others help us understand how you use the service.": "Vi använder cookies för att förbättra din upplevelse. Vissa cookies är nödvändiga för att sidan ska fungera, medan andra hjälper oss att förstå hur du använder tjänsten.",
    "Accept": "Acceptera",
    "Decline": "Neka",

    // AdminLogin
    "Restaurant Dashboard": "Restaurangpanel",
    "Username": "Användarnamn",
    "Switch to Customer App": "Växla till Kundapp",

    // AdminDashboard
    "Måndag": "Måndag",
    "Tisdag": "Tisdag",
    "Onsdag": "Onsdag",
    "Torsdag": "Torsdag",
    "Fredag": "Fredag",
    "Lördag": "Lördag",
    "Söndag": "Söndag",

    // General
    "Invalid promo code": "Ogiltig rabattkod",
    "Reason": "Anledning",
    "Welcome to Biten": "Välkommen till Biten",
    "Invalid credentials": "Felaktiga inloggningsuppgifter",
    "Too many attempts. Please wait a minute before trying again.": "För många försök. Vänta en minut innan du försöker igen.",
    "Wait": "Vänta",
    "article": "artikel",
    "articles": "artiklar",
    "General / Feedback": "Allmänt",
    "Back to orders": "Beställningar",

    // New auth flow
    "Continue": "Fortsätt",
    "Change email": "Byt e-post",
    "First Name": "Förnamn",
    "Last Name": "Efternamn",
    "Repeat Password": "Upprepa lösenord",
    "Address": "Adress",
    "I accept the": "Jag accepterar",
    "and": "och",
    "Passwords do not match": "Lösenorden matchar inte",
    "Password must be at least 8 characters": "Lösenordet måste vara minst 8 tecken",
    "Please fill all required fields": "Fyll i alla obligatoriska fält",
    "You must accept the terms": "Du måste acceptera villkoren",

    // Forgot password
    "Forgot password?": "Glömt lösenord?",
    "Reset your password": "Återställ ditt lösenord",
    "Enter your new password below": "Ange ditt nya lösenord nedan",
    "New Password": "Nytt lösenord",
    "Repeat New Password": "Upprepa nytt lösenord",
    "Reset Password": "Återställ lösenord",
    "Password has been reset successfully": "Lösenordet har återställts",
    "Back to Sign In": "Tillbaka till inloggning",
    "If the email exists, a reset link has been sent.": "Om e-postadressen finns har en återställningslänk skickats.",
    "Invalid or expired reset token": "Ogiltig eller utgången återställningstoken",
    "Check your email": "Kolla din e-post",
    "Show on map": "Visa på karta",
  },
  en: {
    // Cart
    "Your Cart": "Your Cart",
    "Your cart is empty": "Your cart is empty",
    "Remove": "Remove",
    "Checkout": "Checkout",
    "items": "items",
    "item": "item",
    "Estimated Total": "Estimated Total",
    "Out of stock": "Out of stock",
    "Remove sold out items": "Remove sold out items",
    "Some items in your cart are out of stock. Remove them to continue.": "Some items in your cart are out of stock. Remove them to continue.",
    "One or more items are out of stock. Remove them before checkout.": "One or more items are out of stock. Remove them before checkout.",
    "Some items are out of stock. Remove them before placing your order.": "Some items are out of stock. Remove them before placing your order.",

    // Nav
    "Hem": "Home",
    "Meny": "Menu",
    "Orders": "Orders",
    "Om oss": "About Us",
    "Profil": "Profile",
    "Logga in": "Sign In",
    "Admin": "Admin",
    "Ljust läge": "Light mode",
    "Mörkt läge": "Dark mode",
    "Call us": "Call us",
    "Öppna meny": "Open menu",
    "Stäng": "Close",
    "Byt": "Change",
    "Byt restaurang": "Change restaurant",
    "Restaurang & Catering": "Restaurant & Catering",
    "Navigation": "Navigation",
    "Information": "Information",
    "Integritetspolicy": "Privacy Policy",
    "Användarvillkor": "Terms of Service",
    "Noggrant utvalda råvaror, lagade med kärlek och omsorg. Beställ för avhämtning eller leverans.": "Carefully selected ingredients, prepared with love and care. Order for pickup or delivery.",
    "Maten du ser fram emot": "The food you look forward to",
    "hela dagen": "all day long",
    "Avhämtning": "Pickup",
    "Leverans": "Delivery",
    "Catering": "Catering",
    "Färska råvaror": "Fresh ingredients",
    "Lagat med kärlek": "Made with love",
    "Rulla": "Scroll",
    "Utforska menyn": "Explore the menu",
    "En upplevelse,": "An experience,",
    "inte bara en måltid": "not just a meal",
    "Signaturrätt med balanserade smaker och premiumråvaror.": "Signature dish with balanced flavors and premium ingredients.",
    "Bästa Biten": "Bästa Biten",
    "Orderstatus": "Order status",
    "Din beställnings resa": "Your order's journey",
    "We're closed right now and not accepting orders.": "We're closed right now and not accepting orders.",

    // HomePage
    "Choose your Biten": "Choose Your Biten",
    "Where are you? Choose location to see menu and order.": "Where are you? Choose your location to see the menu and place an order.",
    "Luxury Street Dining": "Luxury Street Dining",
    "The food you look forward to all day": "The food you look forward to all day",
    "Order faster, eat better. We combine premium quality with fast delivery.": "Order faster, eat better. We combine premium quality with fast delivery and a menu that makes it easy to pick your favorite.",
    "Menu": "Menu",
    "Why choose us": "Why choose us",
    "Customer rating": "Customer Rating",
    "Dishes": "Dishes",
    "Local zone": "Local Zone",
    "Popular right now": "Popular Right Now",
    "Most popular dishes": "Most Popular Dishes",
    "See full menu": "See Full Menu",
    "Order this in the menu": "Order this in the menu",
    "Menu is being updated. Open menu to see all dishes.": "Menu is being updated. Open the menu to see all available dishes.",
    "Customer feedback": "Customer Feedback",
    "What customers say": "What Customers Say",
    "out of 5 average": "/5 average",
    "Hungry already?": "Hungry Already?",
    "Open the menu and place your order in under a minute.": "Open the menu and place your order in under a minute.",

    // Highlights
    "Premiumsmaker": "Premium Flavors",
    "Säsongsanpassade råvaror och signaturrätter som känns restauranglyxiga hemma.": "Seasonal ingredients and signature dishes that feel restaurant-luxury at home.",
    "Snabbt och smidigt": "Fast & Smooth",
    "Från meny till beställning på minuter, med tydlig orderstatus hela vägen.": "From menu to order in minutes, with clear order status tracking all the way.",
    "Lokalt levererat": "Locally Delivered",
    "Leverans inom vårt lokala område med fokus på temperatur, timing och kvalitet.": "Delivery within our local area with focus on temperature, timing and quality.",
    "Pålitlig service": "Reliable Service",
    "Hundratals nöjda kunder och en upplevelse som är byggd för återbeställning.": "Hundreds of satisfied customers and an experience built around repeat orders.",

    // Highlights English keys (fallback)
    "Premiumsmaker_en": "Premium Flavors",
    "Säsongsanpassade råvaror och signaturrätter som känns restauranglyxiga hemma._en": "Seasonal ingredients and signature dishes that feel restaurant-luxury at home.",
    "Snabbt och smidigt_en": "Fast & Smooth",
    "Från meny till beställning på minuter, med tydlig orderstatus hela vägen._en": "From menu to order in minutes, with clear order status all the way.",
    "Lokalt levererat_en": "Locally Delivered",
    "Leverans inom vårt lokala område med fokus på temperatur, timing och kvalitet._en": "Delivery within our local area with focus on temperature, timing and quality.",
    "Pålitlig service_en": "Reliable Service",
    "Hundratals nöjda kunder och en upplevelse som är byggd för återbeställning._en": "Hundreds of satisfied customers and an experience built for repeat orders.",

    // MenuPage
    "Chef's Pick": "Chef's Pick",
    "TOP PICK": "TOP PICK",
    "Order now": "Order now",
    "No items in this category": "No items in this category",
    "Menu heading": "Menu",

    // ProductDetail
    "Ingredients": "Ingredients",
    "Tap to remove what you don't want": "Tap to remove what you don't want",
    "Extras & Add-ons": "Extras & Add-ons",
    "Customize your order": "Customize your order",
    "Choose one": "Choose one",
    "Add": "Add",
    "Product not found": "Product not found",
    "This product cannot be ordered right now.": "this product cannot be ordered right now.",
    "added to cart": "added to cart",
    "Allergens": "Allergens",
    "Contains the following allergens": "Contains the following allergens",
    "No allergens listed. Ask our staff about allergens before ordering.": "No allergens listed. Ask our staff about allergens before ordering.",
    "Verifiera ditt telefonnummer": "Verify your phone number",
    "För leverans behöver vi kunna nå dig på": "For delivery we need to reach you at",
    "Skicka kod via SMS": "Send code via SMS",
    "Vi har skickat en kod via SMS": "We sent a code via SMS",
    "Kunde inte skicka kod": "Could not send code",
    "Telefonnummer verifierat!": "Phone number verified!",
    "Fel kod": "Wrong code",
    "Verifiera": "Verify",
    "Skicka igen om": "Resend in",
    "Skicka ny kod": "Send new code",
    "Verify your phone number to order delivery.": "Verify your phone number to order delivery.",
    "Verifierar din e-post...": "Verifying your email...",
    "E-post bekräftad!": "Email verified!",
    "Tack! Din e-postadress är nu verifierad.": "Thanks! Your email is now verified.",
    "Länken är ogiltig": "The link is invalid",
    "Länken kan ha gått ut eller redan använts. Begär en ny från din profil.": "The link may have expired or already been used. Request a new one from your profile.",
    "Till profilen": "To profile",
    "Verify email": "Verify email",
    "Resend verification email": "Resend verification email",
    "Verification email sent": "Verification email sent",
    "Verify now": "Verify now",
    "Your email is not verified yet.": "Your email is not verified yet.",

    // Checkout
    "Checkout Title": "Checkout",
    "How would you like your order?": "How would you like your order?",
    "Pickup": "Pickup",
    "Delivery": "Delivery",
    "Delivery Address": "Delivery Address",
    "Street address": "Street address",
    "City": "City",
    "Home": "Home",
    "Work": "Work",
    "Other": "Other",
    "Order Summary": "Order Summary",
    "Subtotal": "Subtotal",
    "Delivery fee": "Delivery fee",
    "Discount": "Discount",
    "Total": "Total",
    "Special Instructions": "Special Instructions",
    "Any allergies, preferences, or messages for the kitchen?": "Any allergies, preferences, or messages for the kitchen?",
    "Place Order": "Place Order",
    "Placing Order...": "Placing Order...",
    "Promo code": "Promo Code",
    "Enter promo code": "Enter promo code",
    "Apply": "Apply",
    "Remove promo": "Remove",
    "Promo code active": "Promo code active",
    "Payment on delivery": "Payment on delivery",
    "Payment on pickup": "Payment on pickup",
    "You pay when you receive your delivery": "You pay when you receive your delivery",
    "You pay when you pick up your order": "You pay when you pick up your order",
    "No card payment needed now.": "– no card payment needed.",
    "Save address to profile?": "Save address to profile?",
    "This address is not saved in your profile. Save it now?": "This address is not saved in your profile. Would you like to save it now?",
    "Address type": "Address type",
    "No, continue": "No, continue",
    "Yes, save": "Yes, save",
    "We're closed and not accepting orders.": "We're closed and not accepting orders.",
    "Pickup temporarily unavailable.": "Pickup is temporarily unavailable.",
    "Delivery temporarily unavailable.": "Delivery is temporarily unavailable.",
    "One or more products are out of stock. Remove them to order.": "One or more products are out of stock. Remove them to order.",
    "Minimum order amount is": "Minimum order amount is",
    "Please enter your delivery address": "Please enter your delivery address",
    "Failed to place order": "Failed to place order",
    "Address saved to profile": "Address saved to profile",
    "Order placed, but address could not be saved": "Order placed, but address could not be saved",
    "Orders temporarily suspended": "Orders temporarily suspended",
    "Min": "Min",
    "required": "required",
    "Restaurant is temporarily not accepting orders.": "Restaurant is temporarily not accepting orders.",
    "Temporarily unavailable": "Temporarily unavailable",

    // Auth
    "Welcome": "Welcome",
    "Welcome back": "Welcome back",
    "Sign in to your account": "Sign in to your account",
    "Sign in to continue": "Sign in to continue",
    "Create Account": "Create Account",
    "Create account": "Create account",
    "Join biten for the best dining experience": "Join biten for the best dining experience",
    "Full Name": "Full Name",
    "Phone Number": "Phone Number",
    "Email": "Email",
    "Email or Phone": "Email or Phone",
    "Password": "Password",
    "Don't have an account?": "Don't have an account?",
    "Sign up": "Sign up",
    "Already have an account?": "Already have an account?",
    "Sign in": "Sign In",
    "Sign In": "Sign In",
    "Please wait...": "Please wait...",
    "Please fill all fields": "Please fill all fields",
    "Something went wrong": "Something went wrong",
    "Welcome back!": "Welcome back!",
    "Account created!": "Account created!",
    "Local test mode": "Local test mode",
    "Switch to Admin Dashboard": "Switch to Admin Dashboard",

    // Profile
    "My Profile": "My Profile",
    "Manage your details and addresses": "Manage your details and addresses",
    "Personal Info": "Personal Info",
    "Edit": "Edit",
    "NAME": "NAME",
    "EMAIL": "EMAIL",
    "PHONE": "PHONE",
    "VERIFIED": "VERIFIED",
    "Yes": "Yes",
    "No": "No",
    "My Addresses": "My Addresses",
    "Add": "Add",
    "Set as default": "Set as default",
    "No address saved": "No address saved",
    "Add first address": "Add first address",
    "Standard": "Default",
    "Account Management": "Account Management",
    "Report a problem": "Contact us",
    "Tell us if you experience any disruptions or issues with the website.": "Questions, or experiencing issues with the website? Write to us here and we'll get back to you.",
    "Describe the problem…": "Write your message…",
    "Send message": "Send message",
    "Please write a message first": "Please write a message first",
    "Thanks! Your message has been sent.": "Thanks! Your message has been sent.",
    "Could not send. Please try again.": "Could not send. Please try again.",
    "Logout": "Logout",
    "Delete Account": "Delete Account",
    "Language": "Language",
    "Switch to English": "Switch to English",
    "Switch to Swedish": "Switch to Swedish",
    "Not logged in": "Not logged in",
    "Go Home": "Go Home",
    "Edit profile": "Edit profile",
    "Name": "Name",
    "Phone": "Phone",
    "Save": "Save",
    "Cancel": "Cancel",
    "Delete": "Delete",
    "Confirm": "Confirm",
    "Back": "Back",
    "Add address": "Add address",
    "You already have this address saved": "You already have this address saved",
    "Street": "Street",
    "Town": "Town",
    "Fill all fields": "Fill all fields",
    "Profile updated": "Profile updated",
    "Failed to load profile": "Failed to load profile",
    "Failed to update profile": "Failed to update profile",
    "Address added": "Address added",
    "Address deleted": "Address deleted",
    "Failed to add address": "Failed to add address",
    "Failed to delete address": "Failed to delete address",
    "Default address updated": "Default address updated",
    "Could not update default address": "Could not update default address",
    "Delete this address?": "Delete this address?",
    "Are you sure you want to delete your account? This cannot be undone.": "Are you sure you want to delete your account? This action cannot be undone.",
    "Your account has been deleted": "Your account has been deleted",
    "Could not delete account": "Could not delete account",
    "Logged out": "Logged out",
    "Fill all address fields": "Fill all address fields",

    // OrderTracking
    "My Orders": "My Orders",
    "Order": "Order",
    "Receipt": "Receipt",
    "Items": "Items",
    "Your note": "Your Note",
    "Delivery address": "Delivery Address",
    "Without": "Without",
    "Cancel order": "Cancel order",
    "Order cancelled": "Order cancelled",
    "Could not cancel": "Could not cancel",
    "Order not found": "Order not found",
    "Rate your order": "Rate Your Order",
    "How was the food? Your rating helps us improve.": "How was the food? Your rating helps us improve.",
    "Leave a comment (optional)...": "Leave a comment (optional)...",
    "Submit review": "Submit Review",
    "Thanks for your review!": "Thanks for your review!",
    "Could not submit review": "Could not submit review",
    "Select number of stars": "Select number of stars",
    "Reorder": "Reorder",
    "Back to menu": "Back to Menu",
    "Problem? Call us:": "Problem? Call us:",
    "Your review": "Your Review",
    "Order again": "Order Again",
    "articles added to cart": "articles added to cart",
    "article": "article",
    "articles": "articles",
    "items added to cart": "items added to cart",
    "products no longer available": "products no longer available",
    "We added the rest to your cart.": "We added the rest to your cart.",
    "Try instead:": "Try instead:",
    "These products are no longer on the menu.": "These products are no longer on the menu.",
    "Could not reorder right now": "Could not reorder right now",
    "Recommendation": "Try ordering something else",

    // Status labels
    "waiting_for_confirmation": "Waiting for restaurant",
    "New": "New",
    "Accepted": "Accepted",
    "Rejected": "Rejected",
    "Preparing": "Preparing",
    "Ready": "Ready",
    "Completed": "Completed",
    "Cancelled": "Cancelled",
    "Paid": "Paid",
    "Confirmed — waiting for preparation": "Confirmed — waiting for preparation",
    "Your food is being prepared...": "Your food is being prepared...",
    "Ready for pickup!": "Ready for pickup!",
    "Waiting for restaurant...": "Waiting for restaurant...",
    "No review yet": "No review yet",

    // OrderHistory
    "Your orders": "Your Orders",
    "Active orders": "Active Orders",
    "Previous orders": "Previous Orders",
    "No orders yet": "No orders yet",
    "See menu": "See Menu",

    // About
    "About Us": "About Us",
    "Get to know the restaurant": "Get to Know the Restaurant",
    "Opening Hours": "OPENING HOURS",
    "Address label": "ADDRESS",
    "Phone label": "PHONE",
    "Services": "Services",
    "Pickup service": "Pickup",
    "Pick up your food at the restaurant": "Pick up your food at the restaurant",
    "Delivery service": "Delivery",
    "We deliver food to your home": "We deliver food to your home",
    "About the restaurant": "About the Restaurant",
    "Delivery Info": "Delivery Info",
    "Delivery fee label": "DELIVERY FEE",
    "Delivery area": "DELIVERY AREA",
    "Up to": "Up to",
    "min away": "min away",
    "Announcement": "Announcement",
    "Gallery": "Gallery",
    "Terms & Privacy": "Terms & Privacy",
    "Privacy Policy": "Privacy Policy",
    "Terms of Service": "Terms of Service",
    "Closed": "Closed",
    "Opening hours not yet set": "Opening hours not yet set",

    // CookieBanner
    "We use cookies to improve your experience. Some cookies are necessary while others help us understand how you use the service.": "We use cookies to improve your experience. Some cookies are necessary while others help us understand how you use the service.",
    "Accept": "Accept",
    "Decline": "Decline",

    // AdminLogin
    "Restaurant Dashboard": "Restaurant Dashboard",
    "Username": "Username",
    "Switch to Customer App": "Switch to Customer App",

    // AdminDashboard
    "Måndag": "Monday",
    "Tisdag": "Tuesday",
    "Onsdag": "Wednesday",
    "Torsdag": "Thursday",
    "Fredag": "Friday",
    "Lördag": "Saturday",
    "Söndag": "Sunday",

    // General
    "Invalid promo code": "Invalid promo code",
    "Reason": "Reason",
    "Welcome to Biten": "Welcome to Biten",
    "Invalid credentials": "Invalid credentials",
    "Too many attempts. Please wait a minute before trying again.": "Too many attempts. Please wait a minute before trying again.",
    "Wait": "Wait",
    "article": "article",
    "articles": "articles",
    "General / Feedback": "General",
    "Back to orders": "Orders",

    // New auth flow
    "Continue": "Continue",
    "Change email": "Change email",
    "First Name": "First Name",
    "Last Name": "Last Name",
    "Repeat Password": "Repeat Password",
    "Address": "Address",
    "I accept the": "I accept the",
    "and": "and",
    "Passwords do not match": "Passwords do not match",
    "Password must be at least 8 characters": "Password must be at least 8 characters",
    "Please fill all required fields": "Please fill all required fields",
    "You must accept the terms": "You must accept the terms",

    // Forgot password
    "Forgot password?": "Forgot password?",
    "Reset your password": "Reset Your Password",
    "Enter your new password below": "Enter your new password below",
    "New Password": "New Password",
    "Repeat New Password": "Repeat New Password",
    "Reset Password": "Reset Password",
    "Password has been reset successfully": "Password has been reset successfully",
    "Back to Sign In": "Back to Sign In",
    "If the email exists, a reset link has been sent.": "If the email exists, a reset link has been sent.",
    "Invalid or expired reset token": "Invalid or expired reset token",
    "Check your email": "Check your email",
    "Show on map": "Show on map",
  }
};
